<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><a href="#/contents#t1" id="c1"><i>dedication</i></a></p>
<p class="txc0">This book is dedicated to Hank Williams, Jr.,</p>
<p class="txc0">who told me to “Saddle up, and go for it.”</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?11aaaf9a